<template>
  <div>
    <el-dialog
      title="服务项明细"
      :visible.sync="listFlag"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="70%"
      @close="closeAddSonDialog"
      append-to-body
    >
      <avue-crud :option="option"
                 :table-loading="loading"
                 :data="data"
                 :page.sync="page"
                 :permission="permissionList"
                 :before-open="beforeOpen"
                 v-model="form"
                 ref="crud"
                 @row-update="rowUpdate"
                 @row-save="rowSave"
                 @row-del="rowDel"
                 @search-change="searchChange"
                 @search-reset="searchReset"
                 @selection-change="selectionChange"
                 @current-change="currentChange"
                 @size-change="sizeChange"
                 @on-load="onLoad"
                 @refresh-change="onLoad"
      >
        <template slot="menuLeft">
        </template>
        <template slot-scope="scope" slot="price">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.price)  }}</span></div>
            </template>
            <template slot-scope="scope" slot="priceForm">
               <moneyInput v-model="form.price"  :disabled="formDisabled"  style= "width: 100%"  /> 
            </template>
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/gateservice/order/orderserviceitem/orderserviceitemlist";
  import {mapGetters} from "vuex";

  var inputNumber = (rule, value, callback) => {
    var regNumber = /^\+?[1-9][0-9]*$/;
    if (!regNumber.test(value)) {
      callback(new Error('请输入大于 0 的正整数！'));
    } else {
      callback();
    }
  };
  export default {
    data() {
      return {
        formDisabled:false,
        listFlag: false,
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 400,
          calcHeight: 120,
          tip: false,
          border: true,
          index: true,
          viewBtn: true,
          selection: false,
          indexLabel: '序号',
          columnBtn: false,
          searchMenuSpan: 18,menuAlign:'center',
          dialogClickModal:false,
          column: [
            {
              label: "服务内容",
              prop: "serviceContent",
              rules: [{
                required: true,
                message: "请输入服务内容",
                trigger: "blur"
              }],
              searchSpan:6,
              overHidden: true,
              maxlength: 50,
              showWordLimit: true,
              search: true,
            },
            {
              label: "分值",
              prop: "score",
              rules: [
                { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入大于 0 的正整数！' },
              ],
              maxlength: 3,
              showWordLimit: true,
            },
            {
              label: '价格(元)',
              prop: 'price',
              maxlength: 12,
              showWordLimit: true,
              slot:true,
              rules: [
                {pattern: /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-999999999.99'},
              ],
              formslot:true
            },
            {
              label: "排序",
              prop: "indexNo",
              rules: [
                {
                  required: true,
                  message: "请输入排序",
                  trigger: "blur"
                },
                {
                  validator: inputNumber,
                  trigger: 'blur',
                },
              ],
              maxlength: 3,
              showWordLimit: true,
            },
            {
              label: "使用频次",
              prop: "useTimes",
              rules: [
                {
                  required:false,
                  message: "请输入权重",
                  trigger: "blur"
                },
                { pattern: /^\d+$/, message: '请输入正整数' },
              ],
              maxlength: 5,
              showWordLimit: true,
            },
            {
              label: "备注",
              prop: "remark",
              overHidden: true,
              maxlength: 200,
              showWordLimit: true,
              span: 24,
              type: 'textarea',
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {

      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (type === 'add') {
          
          console.log(this.query.orderServiceItemId);
          setTimeout(() => {
            this.form.orderServiceItemId = this.query.orderServiceItemId;
            this.form.itemName = this.query.itemName;
          });
        }
        if (type === 'view') {
          this.formDisabled =true
        }else{
          this.formDisabled =false
        }
        if (["edit", "view"].includes(type)) {
          
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        console.log(this.query);
        this.query.serviceContent = '';
        this.onLoad();
      },
      searchChange(params, done) {
        this.query.serviceContent = params.serviceContent;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      openItemListOnload(id,name) {
        this.listFlag = true;
        this.query.orderServiceItemId = id;
        this.query.itemName = name;
        this.onLoad();
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
::v-deep .el-table--small{
  height: 250px!important;
}
::v-deep .avue-form__menu--center{
  text-align: right!important;
}
</style>
